export class ReportTypeItem {
    text: string;
    value: any;
    categoryName?: string;
}
